/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelection } from './bulkSelection';
import type { ShareConfigInsightSectionsItem } from './shareConfigInsightSectionsItem';
import type { ShareConfigInsightsScope } from './shareConfigInsightsScope';
import type { SharePanelsConfig } from './sharePanelsConfig';

export interface ShareConfig {
  panels?: SharePanelsConfig;
  profile_selection?: BulkSelection | null;
  insights_scope?: ShareConfigInsightsScope;
  insight_sections?: ShareConfigInsightSectionsItem[];
}
